import {AfterViewInit, Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

interface State {
  page: number;
  pageOffset: number;
}

@Component({
  selector: 'pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, AfterViewInit {
  @Input() length: number = 1;
  @Input() pageOffset: number = 10;
  @Input() pageIndex: number = 1;
  @Input() titleKey: string = 'pagination.lines_per_page';
  @Input() hidePageSize: boolean = false;

  /** Événement émis à chaque changement de page ou de pageOffset */
  @Output() paginateChange = new EventEmitter<State>();

  /** Observable interne pour gérer la pagination */
  paginate = new BehaviorSubject<State>({
    page: 1,
    pageOffset: 10
  });

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    // Mettre à jour le BehaviorSubject avec les valeurs initiales
    const newState = this.paginate.value;
    newState.page = this.pageIndex;
    newState.pageOffset = this.pageOffset;
    this.paginate.next(newState);

    // S’abonner pour propager tout changement vers le parent
    this.paginate.subscribe((state) => {
      this.paginateChange.emit(state);
    });
  }

  getFirstPage() {
    const newState = this.paginate.value;
    newState.page = this.pageIndex = 1;
    this.paginate.next(newState);
  }

  getNextPage() {
    const newState = this.paginate.value;
    newState.page = this.pageIndex = this.pageIndex + 1;
    this.paginate.next(newState);
  }

  getPreviousPage() {
    const newState = this.paginate.value;
    newState.page = this.pageIndex = this.pageIndex - 1;
    this.paginate.next(newState);
  }

  getLastPage() {
    const newState = this.paginate.value;
    this.pageIndex = (this.length % this.pageOffset === 0)
        ? (this.length / this.pageOffset)
        : (Math.floor(this.length / this.pageOffset) + 1);

    newState.page = this.pageIndex;
    this.paginate.next(newState);
  }

  updatePageSize() {
    const newState = this.paginate.value;
    newState.page = this.pageIndex = 1;
    newState.pageOffset = this.pageOffset;
    this.paginate.next(newState);
  }
}
